/**
 * Trigger browser print dialog for PDF download of a DOM element.
 */
export function printElementAsPdf(elementId, title = 'Report') {
  const el = document.getElementById(elementId);
  if (!el) {
    window.print();
    return;
  }

  const prevTitle = document.title;
  document.title = title;

  const style = document.createElement('style');
  style.id = 'pdf-print-style';
  style.textContent = `
    @media print {
      body * { visibility: hidden !important; }
      #${elementId}, #${elementId} * { visibility: visible !important; }
      #${elementId} {
        position: absolute !important;
        left: 0; top: 0; width: 100%;
        box-shadow: none !important;
        border: none !important;
      }
      .no-print { display: none !important; }
    }
  `;
  document.head.appendChild(style);
  window.print();
  document.title = prevTitle;
  setTimeout(() => style.remove(), 500);
}
